import React, { useState, useEffect } from "react";
import {
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  CircularProgress,
  Typography,
  Button,
} from "@mui/material";
import { FaCloudUploadAlt } from "react-icons/fa";
import axios from "axios";

function Inprocess() {
  const [tab, setTab] = useState("single");
  const [currentPage, setCurrentPage] = useState(1);
  const [ideaData, setIdeaData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const rowsPerPage = 5;

  // Fetch idea submissions
  useEffect(() => {
    const fetchIdeas = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axios.get("https://puneexpobackend.tdtlworld.com/api/get_idea_submission/");
        setIdeaData(response.data || []); // Set the data or empty array
      } catch (err) {
        setError("Failed to fetch ideas. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchIdeas();
  }, []);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
    setCurrentPage(1);
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  // Handle status change to approved
  const handleApprove = async (id) => {
    try {
      const payload = { status: "approved" };
      const response = await axios.patch(`https://puneexpobackend.tdtlworld.com/api/change_status/${id}/`, payload);
      if (response.data) {
        setIdeaData((prevData) =>
          prevData.map((idea) =>
            idea.id === id ? { ...idea, status: "approved" } : idea
          )
        );
      }
    } catch (err) {
      console.error("Error updating status:", err);
      setError("Failed to approve. Please try again.");
    }
  };

  const renderTable = () => {
    const filteredData = ideaData.filter(
      (idea) => idea.status === "inprogressed" // Filter only ideas with status 'inprogressed'
    );

    const startIndex = (currentPage - 1) * rowsPerPage;
    const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);

    if (currentData.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={6} align="center">
            <Typography variant="body1" color="textSecondary">
              Currently no projects in progress.
            </Typography>
          </TableCell>
        </TableRow>
      );
    }

    return (
      <TableBody>
        {currentData.map((row, index) => (
          <TableRow key={row.id}>
            <TableCell>{index + 1 + (currentPage - 1) * rowsPerPage}</TableCell>
            <TableCell>{row.title || "N/A"}</TableCell>
            <TableCell>{row.description || "N/A"}</TableCell>
            <TableCell>{new Date(row.created_at).toLocaleString()}</TableCell>
            <TableCell align="center">
              {row.uploadedFile && <FaCloudUploadAlt style={{ color: "#007BFF" }} />}
            </TableCell>
            <TableCell align="center">
              <Button
                variant="contained"
                color="success"
                size="small"
                onClick={() => handleApprove(row.id)}
              >
                Approve
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    );
  };

  return (
    <Box sx={{ margin: "70px", padding: "20px", textAlign: "center" }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        In Progress
      </Typography>

      {/* Tabs */}
      <Box sx={{ marginBottom: "20px", display: "flex", justifyContent: "center" }}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab value="single" label="Single" />
          <Tab value="group" label="Group" />
        </Tabs>
      </Box>

      {/* Table and Loading/Error States */}
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography variant="body1" color="error">
          {error}
        </Typography>
      ) : (
        <TableContainer
          component={Paper}
          sx={{ maxWidth: "800px", margin: "0 auto", backgroundColor: "#E8F4FA" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Created At</TableCell>
                <TableCell align="center">Uploaded File</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            {renderTable()}
          </Table>
        </TableContainer>
      )}

      {/* Pagination */}
      {!loading && !error && (
        <Box sx={{ margin: "20px auto", display: "flex", justifyContent: "center" }}>
          <Pagination
            count={Math.ceil(
              ideaData.filter((idea) => idea.status === "inprogressed").length / rowsPerPage
            )}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
}

export default Inprocess;
